
function zeropad(n, digits) {
	var s = n.toString();
	while(s.length < digits)
		s = '0' + s;
	return s;
}

var Class = require('./class.js');

var CDate = module.exports.CDate = Class(null, {
	shortDayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
	longDayNames: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
	shortMonthNames: ['Invalid', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	longMonthNames: ['Invalid', 'January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

	__init__: function(year, month, day) {
		if(year)
			this.d = new Date(year, month - 1, day);
		else
			this.d = new Date();
		this.year = this.d.getFullYear();
		this.month = this.d.getMonth() + 1;
		this.day = this.d.getDate();
		this.dow = this._mapdow(this.d.getDay());
	},

	copy: function() {
		return new CDate(this.year, this.month, this.day);
	},

	_mapdow: function(dow) {		/* translate from a JS .getDay() into a sensible day-index */
		if(dow == 0)
			return 6;
		return dow - 1;
	},

	lastMonday: function() {		/* returns a new CDate which is a Monday on or before this instance */
		var current = new Date(this.d);
		while(current.getDay() != 1)
			current.setDate(current.getDate() - 1);
		return new CDate(current.getFullYear(), current.getMonth() + 1, current.getDate());
	},

	addMonths: function(nMonths) {	/* returns a new CDate which is nMonths after this instance */
		var current = new Date(this.d);
		if(nMonths > 0) {
			for(var i = 0; i < nMonths; i++)
				current.setMonth(current.getMonth() + 1);
		}
		else {
			nMonths = -nMonths;
			for(var i = 0; i < nMonths; i++)
				current.setMonth(current.getMonth() - 1);
		}
		return new CDate(current.getFullYear(), current.getMonth() + 1, current.getDate());
	},

	addDays: function(nDays) {		/* returns a new CDate which is nDays after this instance (-'ve supported) */
		var current = new Date(this.d);
		if(nDays > 0) {
			for(var i = 0; i < nDays; i++)
				current.setDate(current.getDate() + 1);
		}
		else {
			nDays = -nDays;
			for(var i = 0; i < nDays; i++)
				current.setDate(current.getDate() - 1);
		}
		return new CDate(current.getFullYear(), current.getMonth() + 1, current.getDate());
	},

	toString: function() {
		return this.strftime('%Y-%m-%d');
	},

	daysTo: function(other, inclusive) {
		return Math.floor((other.d - this.d) / 86400000) + (inclusive ? 1 : 0);
	},

	toUTC: function() {
		return this.d / 1000;
	},

	setDay: function(day) {
		this.d.setDate(day);
		this.day = day;
		this.dow = this._mapdow(this.d.getDay());
	},

	cmp: function(other) {	/* returns -1 if other < this, +1 if other > this, and 0 if other == this */
		if(other.year < this.year)
			return -1;
		else if(other.year > this.year)
			return 1;
		if(other.month < this.month)
			return -1;
		else if(other.month > this.month)
			return 1;
		if(other.day < this.day)
			return -1;
		else if(other.day > this.day)
			return 1;
		return 0;
	},

	isLT: function(other) {
		return this.cmp(other) > 0;
	},

	isLE: function(other) {
		return this.cmp(other) >= 0;
	},

	isGT: function(other) {
		return this.cmp(other) < 0;
	},

	isGE: function(other) {
		return this.cmp(other) <= 0;
	},

	isEqual: function(other) {
		return this.cmp(other) == 0;
	},

	strftime: function(fmt) {
		var pct = false;
		var output = '';
		for(var i = 0; i < fmt.length; i++) {
			var ch = fmt.charAt(i);
			if(pct) {
				if(ch == '%')
					output += '%';
				else if(ch == 'a')
					output += this.shortDayNames[this.dow];
				else if(ch == 'A')
					output += this.longDayNames[this.dow];
				else if(ch == 'b')
					output += this.shortMonthNames[this.month];
				else if(ch == 'B')
					output += this.longMonthNames[this.month];
				else if(ch == 'd')
					output += zeropad(this.day, 2);
				else if(ch == 'm')
					output += zeropad(this.month, 2);
				else if(ch == 'Y')
					output += this.year;
				else if(ch == 'y')
					output += this.year.toString().substring(2, 4);
				pct = false;
			}
			else {
				if(ch == '%')
					pct = true;
				else
					output += ch;
			}
		}
		return output;
	}
});

var CTime = module.exports.CTime = Class(null, {

	__init__: function(hours, minutes, seconds) {
		if(hours === undefined) {
			var d = new Date();
			this.hours = d.getHours();
			this.minutes = d.getMinutes();
			this.seconds = d.getSeconds();
		}
		else {
			this.hours = hours;
			this.minutes = minutes || 0;
			this.seconds = seconds || 0;
		}
	},

	cmp: function(other) {
		if(this.hours < other.hours)
			return -1;
		else if(this.hours > other.hours)
			return 1;
		if(this.minutes < other.minutes)
			return -1;
		else if(this.minutes > other.minutes)
			return 1;
		if(this.seconds < other.seconds)
			return -1;
		else if(this.seconds > other.seconds)
			return 1;
		return 0;
	},

	asSeconds: function() {
		var seconds = this.seconds;
		seconds += (this.minutes * 60);
		seconds += (this.hours * 3600);
		return seconds;
	},

	toString: function(fmt) {
		if(fmt)
			return this.hours + ':' + zeropad(this.minutes, 2) + ':' + zeropad(this.seconds, 2);
		else
			return this.hours + ':' + zeropad(this.minutes, 2);
	},

	strftime: function(fmt) {
		var pct = false;
		var output = '';
		for(var i = 0; i < fmt.length; i++) {
			var ch = fmt.charAt(i);
			if(pct) {
				if(ch == '%')
					output += '%';
				else if(ch == 'H')
					output+= this.hours;
				else if(ch == 'h')
					output+= zeropad(this.hours, 2);
				else if(ch == 'I') {
					if(this.hours == 0)
						output += 12;
					else if(this.hours <= 12)
						output += this.hours;
					else
						output += (this.hours - 12);
				}
				else if(ch == 'p') {
					if(this.hours < 12)
						output += 'AM';
					else
						output += 'PM';
				}
				else if(ch == 'M')
					output += zeropad(this.minutes, 2);
				else if(ch == 'S')
					output += zeropad(this.seconds, 2);
				pct = false;
			}
			else {
				if(ch == '%')
					pct = true;
				else
					output += ch;
			}
		}
		return output;
	}
});


var CDateTime = module.exports.CDateTime = Class(null, {

	__init__: function(date, time) {
		if(date)
			this.date = date;
		else
			this.date = new CDate();
		if(time)
			this.time = time;
		else
			this.time = new CTime();
	},

	fromTimestamp: function(timestamp) {
		var d = new Date(timestamp * 1000);
		return new CDateTime(new CDate(d.getFullYear(), d.getMonth() + 1, d.getDate()), new CTime(d.getHours(), d.getMinutes(), d.getSeconds()));
	},

	parse: function(s) {
		var dt = new Date(Date.parse(s));
		return new CDateTime(new CDate(dt.getFullYear(), dt.getMonth() + 1, dt.getDate()), new CTime(dt.getHours(), dt.getMinutes(), dt.getSeconds()));
	},

	strffuzzy: function(){
		var time_formats = [
			[20, 'Just now', 1], // 60
			[60, 'seconds', 1],
			[120, '1 minute ago', '1 minute from now'], // 60*2
			[3600, 'minutes', 60], // 60*60, 60
			[7200, '1 hour ago', '1 hour from now'], // 60*60*2
			[86400, 'hours', 3600], // 60*60*24, 60*60
			[172800, 'Yesterday', 'tomorrow'], // 60*60*24*2
			[604800, 'days', 86400], // 60*60*24*7, 60*60*24
			[1209600, 'Last week', 'next week'], // 60*60*24*7*4*2
			[2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
			[4838400, 'Last month', 'next month'], // 60*60*24*7*4*2
			[29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
			[58060800, 'Last year', 'next year'], // 60*60*24*7*4*12*2
			[2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
		];
		var seconds = (new Date()  - ((this.date.d - 0) + (((this.time.hours * 60 * 60) + (this.time.minutes * 60) + (this.time.seconds)) * 1000))) / 1000;
		var token = 'ago', list_choice = 1;
		var i = 0, format;
		while (format = time_formats[i++]){
			if (seconds < format[0]) {
				if (typeof format[2] == 'string' || seconds < 20)
					return format[list_choice];
				else
					return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
			}
		}
		return time;
	}
});


var Timezone = module.exports.Timezone = {
	calculate: function() {
		var d = new Date(2007, 4, 1);
		var offset = - d.getTimezoneOffset();
		if(offset == 60)	/* GMT+0100 */
			return 'Europe/London';
		else if(offset == 720)	/* GMT+1200 */
			return 'Pacific/Auckland';
		else if(offset == 480)	/* GMT+0800 */
			return 'Australia/Perth';
		else if(offset == 570) {	/* GMT+0930 */
			var d = new Date(2007, 2, 1);
			var offset = - d.getTimezoneOffset();
			if(offset == 570)
				return 'Australia/Darwin';		/* No DST */
			else
				return 'Australia/Adelaide';	/* AS DST */
		}
		else if(offset == 600) {	/* GMT+1000 */
			var d = new Date(2007, 2, 1);
			var offset = - d.getTimezoneOffset();
			if(offset == 600)
				return 'Australia/Brisbane';	/* No DST */
			else {
				var d = new Date(2007, 9, 15);
				var offset = - d.getTimezoneOffset();
				if(offset == 600)
					return 'Australia/Melbourne';		/* AV DST */
				else
					return 'Australia/Hobart';	/* AT DST */
			}
		}
		return null;		/* Unknown / Not implemented yet */
	}
};

